"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Repeat = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 8,
  height: 8,
  viewBox: "0 0 8 8"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M.024 4.96A.379.379 0 0 0 0 5.092v2.181c0 .201.156.364.348.364a.356.356 0 0 0 .348-.364v-1.34l1.02 1.001a3.379 3.379 0 0 0 3.227.976c1.165-.275 2.113-1.156 2.512-2.334a.368.368 0 0 0-.212-.464.344.344 0 0 0-.444.222C6.48 6.275 5.722 6.98 4.79 7.2c-.93.22-1.906-.075-2.59-.789l-.973-.957h1.209a.356.356 0 0 0 .348-.364c0-.2-.156-.363-.348-.363H.348a.348.348 0 0 0-.323.227l-.001.005zm7.952-1.92A.379.379 0 0 0 8 2.908V.727c0-.201-.156-.364-.348-.364a.356.356 0 0 0-.348.364v1.34l-1.02-1.001A3.379 3.379 0 0 0 3.057.09C1.892.365.944 1.246.545 2.424c-.064.189.03.397.212.464a.344.344 0 0 0 .444-.222C1.52 1.725 2.278 1.02 3.21.8c.93-.22 1.906.075 2.59.789l.973.957H5.565a.356.356 0 0 0-.348.364c0 .2.156.363.348.363h2.087a.348.348 0 0 0 .323-.227l.001-.005z"
}));

var _default = Repeat;
exports.default = _default;